import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Header from '../header/Header';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';
import { API_URL, MENU_ITEMS } from '../../Constants';
import { useNavigate } from 'react-router-dom';
import { axiosClient } from '../AxiosClient';

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#BADEC1',
    },
});

let apiUrl = API_URL;
const items = MENU_ITEMS;

export default function LoginAdmin() {

    const navigate = useNavigate();

    const handleAdminLogin = () => {
        let username = document.getElementById("username").value;
        let password = document.getElementById("password").value;
        if (username == "" || password == "") {
            alert("Revisa los campos obligatorios")
        } else {
            sendLoginRequest(username, password)
        }
    }

    function sendLoginRequest(username, password) {
        axiosClient.get('/v1/users/username/' + username + '/password/' + password)
        .then(response => {
            const users = response.data;
            localStorage.setItem("userUuid", users.uuid);
            localStorage.setItem("permits", users.rol.permits);
            window.location.href = items[`${JSON.parse(users.rol.permits).items[0]}`];
        })
        .catch(error => {
            if(error.response) {
                alert("Usuario o contraseña incorrectos")
                console.log("User doesn´t exist");
            } else {
                console.log("Bad petition:" + error.message);
            }
        })
    }

    return (
        <React.Fragment>
            <Header isLoggedIn={false}/>
            <Box>
                <Container maxWidth="md">
                    <br />
                    <br />
                    <br />
                    <Box sx={{ flexGrow: 1, marginTop: '10vh' }}>
                        <Grid container spacing={3}>
                            <Grid item xs />
                            <Grid item xs={7}>
                                <Stack spacing={7}>
                                    <h1 style={{ fontSize: 50, textAlign: 'center' }}>Ingreso Administradores</h1>
                                    <TextField id="username" label="Usuario" variant="outlined" />
                                    <TextField id="password" type="password" label="Contraseña" variant="outlined" />
                                    <ButtonPrincipal variant="contained" onClick={handleAdminLogin}>Ingresar</ButtonPrincipal>
                                </Stack>
                            </Grid>
                            <Grid item xs />
                        </Grid>
                    </Box>
                </Container>
            </Box>
        </React.Fragment>
    );
}